import Component from './ModelViewerLeaf.component';

export default Component;
